export default {"frames": [

{
	"filename": "01_one-eyes.png",
	"frame": {"x":1,"y":1,"w":365,"h":281},
	"rotated": false,
	"trimmed": true,
	"spriteSourceSize": {"x":76,"y":117,"w":365,"h":281},
	"sourceSize": {"w":512,"h":512}
},
{
	"filename": "02_one-eyes.png",
	"frame": {"x":1,"y":284,"w":364,"h":299},
	"rotated": false,
	"trimmed": true,
	"spriteSourceSize": {"x":76,"y":117,"w":364,"h":299},
	"sourceSize": {"w":512,"h":512}
},
{
	"filename": "03_one-eyes.png",
	"frame": {"x":1,"y":585,"w":363,"h":278},
	"rotated": false,
	"trimmed": true,
	"spriteSourceSize": {"x":74,"y":117,"w":363,"h":278},
	"sourceSize": {"w":512,"h":512}
}],
"meta": {
	"app": "https://www.codeandweb.com/texturepacker",
	"version": "1.0",
	"image": "one-eye.png",
	"format": "RGBA8888",
	"size": {"w":512,"h":1024},
	"scale": "1",
	"smartupdate": "$TexturePacker:SmartUpdate:c5303217044c3dbfac30d21cb2c3e24a:23459eee0b8872090b82993a71056eda:aab4fdbbdd40309af8299ae1cd8c907b$"
}
}
